export default __webpack_public_path__ + "static/media/PHYSICS_71.40aab489.png";